import { gql } from 'graphql.macro';
import { deliveryOrdersFragment } from 'apollo/fragments';

// DD-3800: Production › Overview. Counts come in per-day buckets with orderCount and
// actionCount side by side, so the Orders|Actions toggle is a pure client-side switch.

export const productionOverviewInboxTemplate = gql`
    query productionOverviewInbox($clinicId: MongoDbObjectId) {
        productionOverviewInbox(clinicId: $clinicId) {
            orderCount
            actionCount
        }
    }
`;

export const productionOverviewReceivedTemplate = gql`
    query productionOverviewReceived($filter: ProductionOverviewFilterInput!) {
        productionOverviewReceived(filter: $filter) {
            byCustomer {
                day
                orderCount
                actionCount
            }
            viaScannerCase {
                day
                orderCount
                actionCount
            }
            viaOrderForm {
                day
                orderCount
                actionCount
            }
            createdManually {
                day
                orderCount
                actionCount
            }
        }
    }
`;

export const productionOverviewProductionTemplate = gql`
    query productionOverviewProduction($filter: ProductionOverviewFilterInput!) {
        productionOverviewProduction(filter: $filter) {
            productionFinished {
                day
                orderCount
                actionCount
            }
            sentToClinic {
                day
                orderCount
                actionCount
            }
            deadline {
                day
                orderCount
                actionCount
            }
            deliveryToCustomer {
                day
                orderCount
                actionCount
            }
            lateToday {
                orderCount
                actionCount
            }
            withoutDeadline {
                orderCount
                actionCount
            }
        }
    }
`;

export const productionOverviewSnapshotTemplate = gql`
    query productionOverviewSnapshot($clinicId: MongoDbObjectId) {
        productionOverviewSnapshot(clinicId: $clinicId) {
            departmentId
            departmentName
            steps {
                stepId
                stepName
                orderCount
                lateCount
                pausedCount
            }
        }
    }
`;

// The click-through list: the Delivery schedule columns plus the new "Came in via"
// column and the per-order action count the Actions-mode heading is summed from.
export const productionOverviewOrdersTemplate = gql`
    query productionOverviewOrders($cell: ProductionOverviewCellInput!) {
        productionOverviewOrders(cell: $cell) {
            ...deliveryOrdersFields
            cameInVia
            actionsCount
        }
    }
    ${deliveryOrdersFragment}
`;
